import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { ImportLearnerService } from "src/app/_services/import-services/import-learner.service";
import {
  AuthorizeSSE,
  AuthorizeSSEError,
  AuthorizeSSESuccess,
  CancelImport,
  CancelImportError,
  CancelImportSuccess,
  CancelImportTutor,
  ClearImportSession,
  ClearImportTutorSession,
  DownloadErrorList,
  DownloadErrorListError,
  DownloadErrorListSuccess,
  DownloadErrorTutorList,
  HasImport,
  HasImportError,
  HasImportSuccess,
  HasImportTutor,
  ResetImportState,
  UploadCSV,
  UploadCSVError,
  UploadCSVSuccess,
  UploadTutorCSV,
} from "./import.actions";
import { catchError, map, switchMap, tap } from "rxjs/operators";
import { HttpErrorResponse } from "@angular/common/http";
import { of } from "rxjs";
import { ImportTutorService } from "src/app/_services/import-services/import-tutor.service";

@Injectable()
export class ImportEffects {
  constructor(
    private actions$: Actions,
    private importLearnerService: ImportLearnerService,
    private importTutorService: ImportTutorService
  ) {}

  public uploadLearnerCSVEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UploadCSV),
      switchMap((payload) =>
        this.importLearnerService.uploadCSVFile$(payload.payload).pipe(
          map((result: boolean) => {
            return UploadCSVSuccess({ result: result });
          }),
          catchError((error: HttpErrorResponse) => {
            return of(UploadCSVError({ error: error }));
          })
        )
      )
    )
  );

  public uploadTutorCSVEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UploadTutorCSV),
      switchMap((payload) =>
        this.importTutorService.uploadCSVFile$(payload.payload).pipe(
          map((result: boolean) => {
            return UploadCSVSuccess({ result: result });
          }),
          catchError((error: HttpErrorResponse) => {
            return of(UploadCSVError({ error: error }));
          })
        )
      )
    )
  );

  public authorizeSSERequestEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthorizeSSE),
      switchMap(() =>
        this.importLearnerService.authorizeSSERequest$().pipe(
          map((result: boolean) => {
            return AuthorizeSSESuccess({ result: result });
          }),
          catchError((error: HttpErrorResponse) => {
            return of(AuthorizeSSEError({ error: error }));
          })
        )
      )
    )
  );

  public downloadErrorListEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DownloadErrorList),
      switchMap(() =>
        this.importLearnerService.downloadErrorList$().pipe(
          map((result: string[]) => {
            return DownloadErrorListSuccess({ result: result });
          }),
          catchError((error: HttpErrorResponse) => {
            return of(DownloadErrorListError({ error: error }));
          })
        )
      )
    )
  );

  public downloadErrorTutorListEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DownloadErrorTutorList),
      switchMap(() =>
        this.importTutorService.downloadErrorList$().pipe(
          map((result: string[]) => {
            return DownloadErrorListSuccess({ result: result });
          }),
          catchError((error: HttpErrorResponse) => {
            return of(DownloadErrorListError({ error: error }));
          })
        )
      )
    )
  );

  public hasImportEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(HasImport),
      switchMap(() =>
        this.importLearnerService.hasImport$().pipe(
          map((result: number) => {
            return HasImportSuccess({ result: result });
          }),
          catchError((error: HttpErrorResponse) => {
            return of(HasImportError({ error: error }));
          })
        )
      )
    )
  );

  public hasImportTutorEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(HasImportTutor),
      switchMap(() =>
        this.importTutorService.hasImport$().pipe(
          map((result: number) => {
            return HasImportSuccess({ result: result });
          }),
          catchError((error: HttpErrorResponse) => {
            return of(HasImportError({ error: error }));
          })
        )
      )
    )
  );

  public clearImportSessionEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ClearImportSession),
      switchMap(() =>
        this.importLearnerService.clearImportSession$().pipe(
          map(() => {
            return ResetImportState();
          })
        )
      )
    )
  );
  
  public clearImportTutorSessionEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ClearImportTutorSession),
      switchMap(() =>
        this.importTutorService.clearImportSession$().pipe(
          map(() => {
            return ResetImportState();
          })
        )
      )
    )
  );
  
  public cancelImportEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CancelImport),
      switchMap(() =>
        this.importLearnerService.cancelImport$().pipe(
          map(() => {
            return CancelImportSuccess();
          }),
          catchError(() => {
            return of(CancelImportError());
          })
        )
      )
    )
  );

  public cancelImportTutorEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CancelImportTutor),
      switchMap(() =>
        this.importTutorService.cancelImport$().pipe(
          map(() => {
            return CancelImportSuccess();
          }),
          catchError(() => {
            return of(CancelImportError());
          })
        )
      )
    )
  );
}
